// @flow

import React from 'react';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

// If you used a style file, e.g. RemoveKeywordTriggerDialog.Style.js, import it here
// but often a confirm dialog is small enough to style inline

type Props = {
  open: boolean,
  setOpen: (val: boolean) => void,
  keyword: any, // the keyword object to remove
  actionConfirm: () => void
};

const RemoveKeywordTriggerDialog = (props: Props) => {
  const { open, setOpen, keyword, actionConfirm } = props;
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    actionConfirm();
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {'Remove this Keyword?'}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {`Are you sure you want to remove the keyword "${keyword?.Keyword}"?`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {'Cancel'}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
        >
          {'Remove'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveKeywordTriggerDialog;